"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Base class for data item.
 *
 * Copyright (C) 2018D Noom, Inc.
 * @author hubert
*/
var Item = /*#__PURE__*/function () {
  function Item() {
    _classCallCheck(this, Item);
  }

  _createClass(Item, [{
    key: "markUpdated",
    value: function markUpdated() {
      if (this.constructor.store) {
        this.constructor.store.markUpdated(this.key);
      }
    }
  }]);

  return Item;
}();

Item.wrap = function (item) {
  var __ = {
    timestamp: new Date().getTime(),
    item: item,
    clone: function clone() {
      return Item.wrap(item);
    }
  };
  return new Proxy(item, {
    get: function get(target, propKey) {
      if (propKey === "_") {
        return __;
      }

      return target[propKey];
    }
  });
};

var _default = Item;
exports["default"] = _default;